//This function parses text containing HTML entities/numbers by retrieving the text from an HTML textarea.
export default (titleText) => {
    let txt = document.createElement("textarea");
    txt.innerHTML = titleText;
    return txt.value;
}